export type BrowseInventoryPhase = 'loading' | 'ready' | 'error'

export interface BrowseStartupPresentation {
  headerProgress: boolean
  showSummary: boolean
  showEmptyState: boolean
  showLoadError: boolean
}

/**
 * Keeps Browse neutral until every local note page has been checked. Cards may
 * appear progressively, but a zero count is authoritative only in `ready`.
 */
export function browseStartupPresentation(
  phase: BrowseInventoryPhase,
  resultCount: number,
): BrowseStartupPresentation {
  return {
    headerProgress: phase === 'loading',
    showSummary: resultCount > 0 || phase === 'ready',
    showEmptyState: resultCount === 0 && phase === 'ready',
    showLoadError: phase === 'error',
  }
}
